'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.connectMapioComponent = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _AbstractReactComponent = require('../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _authActions = require('../actions/authActions');

var _frame = require('../frame');

var _FrameActions = require('../frame/FrameActions');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Základ pro mapio komponenty postavené na iframe.
 */
var AbstractMapioComponent = function (_AbstractReactCompone) {
    (0, _inherits3.default)(AbstractMapioComponent, _AbstractReactCompone);

    function AbstractMapioComponent() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AbstractMapioComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AbstractMapioComponent.__proto__ || (0, _getPrototypeOf2.default)(AbstractMapioComponent)).call.apply(_ref, [this].concat(args))), _this), _this.handleMessage = function (message) {
            switch (message.type) {
                case 'READY':
                    _this.resumePost(); // Až teď můžeme začít komunikovat a poslat výchozí konfiguraci
                    break;

                case 'EVENT':
                    _this.handleEvent(message.event);
                    break;

                default:
                    console.warn('Unrecognized message', message);
                    break;
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AbstractMapioComponent, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.suspendPost();
            this.postDefaults();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            var props = this.props,
                propsToSync = this.propsToSync;

            if (propsToSync) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(propsToSync), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var name = _step.value;

                        if (!_utils.StoreUtils.objectEquals(props[name], newProps[name])) {
                            this.postProperty(name, newProps[name]);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    }, {
        key: 'suspendPost',
        value: function suspendPost() {
            var area = this.props.area;

            this.dispatch((0, _FrameActions.setPostSuspended)(area, true));
        }
    }, {
        key: 'resumePost',
        value: function resumePost() {
            var area = this.props.area;

            this.dispatch((0, _FrameActions.setPostSuspended)(area, false));
        }
    }, {
        key: 'postDefaults',
        value: function postDefaults() {
            var props = this.props,
                propsToSync = this.propsToSync;

            if (propsToSync) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = (0, _getIterator3.default)(propsToSync), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var name = _step2.value;

                        this.postProperty(name, props[name]);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            this.componentPostedDefaults();
        }
    }, {
        key: 'componentPostedDefaults',
        value: function componentPostedDefaults() {}
    }, {
        key: 'postProperty',
        value: function postProperty(name, value) {
            var area = this.props.area;

            this.dispatch((0, _FrameActions.postMessage)(area, { type: 'PROPERTY_SET', name: name, value: value }));
        }
    }, {
        key: 'handleEvent',
        value: function handleEvent(event) {
            var onEvent = this.props.onEvent;

            if (onEvent) {
                onEvent(event);
            }
        }
    }, {
        key: 'buildURLOptions',
        value: function buildURLOptions(path) {
            var _props = this.props,
                auth = _props.auth,
                topic = _props.topic,
                _props$context = _props.context,
                origContext = _props$context === undefined ? {} : _props$context,
                _props$params = _props.params,
                params = _props$params === undefined ? {} : _props$params;

            var context = (0, _extends3.default)({}, origContext);
            if (auth && auth.data) {
                context.login = auth.data.loginEncoded;
            }
            return (0, _extends3.default)({}, params, { path: path, context: context, topic: topic });
        }
    }, {
        key: 'renderFrame',
        value: function renderFrame(_ref2) {
            var className = _ref2.className,
                src = _ref2.src,
                area = _ref2.area,
                otherProps = (0, _objectWithoutProperties3.default)(_ref2, ['className', 'src', 'area']);

            return _react2.default.createElement(_frame.Frame, (0, _extends3.default)({ className: className, src: src, area: area, onMessage: this.handleMessage }, otherProps));
        }
    }]);
    return AbstractMapioComponent;
}(_AbstractReactComponent2.default);

/**
 * Napojení do redux store, které používají komponenty dědící od AbstractMapioComponent.
 */


exports.default = AbstractMapioComponent;
var connectMapioComponent = exports.connectMapioComponent = (0, _reactRedux.connect)(function (state) {
    return { auth: (0, _utils.storeFromArea)(state, _authActions.AUTH_INFO_AREA) };
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvbWFwaW8vQWJzdHJhY3RNYXBpb0NvbXBvbmVudC5qc3giXSwibmFtZXMiOlsiQWJzdHJhY3RNYXBpb0NvbXBvbmVudCIsImhhbmRsZU1lc3NhZ2UiLCJtZXNzYWdlIiwidHlwZSIsInJlc3VtZVBvc3QiLCJoYW5kbGVFdmVudCIsImV2ZW50IiwiY29uc29sZSIsIndhcm4iLCJzdXNwZW5kUG9zdCIsInBvc3REZWZhdWx0cyIsIm5ld1Byb3BzIiwicHJvcHMiLCJwcm9wc1RvU3luYyIsIm5hbWUiLCJTdG9yZVV0aWxzIiwib2JqZWN0RXF1YWxzIiwicG9zdFByb3BlcnR5IiwiYXJlYSIsImRpc3BhdGNoIiwiY29tcG9uZW50UG9zdGVkRGVmYXVsdHMiLCJ2YWx1ZSIsIm9uRXZlbnQiLCJwYXRoIiwiYXV0aCIsInRvcGljIiwiY29udGV4dCIsIm9yaWdDb250ZXh0IiwicGFyYW1zIiwiZGF0YSIsImxvZ2luIiwibG9naW5FbmNvZGVkIiwiY2xhc3NOYW1lIiwic3JjIiwib3RoZXJQcm9wcyIsIkFic3RyYWN0UmVhY3RDb21wb25lbnQiLCJjb25uZWN0TWFwaW9Db21wb25lbnQiLCJzdGF0ZSIsIkFVVEhfSU5GT19BUkVBIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7OztBQUNBOztBQUNBOzs7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7Ozs7QUFFQTs7O0lBR3FCQSxzQjs7Ozs7Ozs7Ozs7Ozs7Z1BBcURqQkMsYSxHQUFnQixtQkFBVztBQUN2QixvQkFBUUMsUUFBUUMsSUFBaEI7QUFDSSxxQkFBSyxPQUFMO0FBQ0ksMEJBQUtDLFVBQUwsR0FESixDQUN1QjtBQUNuQjs7QUFFSixxQkFBSyxPQUFMO0FBQ0ksMEJBQUtDLFdBQUwsQ0FBaUJILFFBQVFJLEtBQXpCO0FBQ0E7O0FBRUo7QUFDSUMsNEJBQVFDLElBQVIsQ0FBYSxzQkFBYixFQUFxQ04sT0FBckM7QUFDQTtBQVhSO0FBYUgsUzs7Ozs7NkNBakVvQjtBQUNqQixpQkFBS08sV0FBTDtBQUNBLGlCQUFLQyxZQUFMO0FBQ0g7OztrREFFeUJDLFEsRUFBVTtBQUFBLGdCQUN6QkMsS0FEeUIsR0FDSCxJQURHLENBQ3pCQSxLQUR5QjtBQUFBLGdCQUNsQkMsV0FEa0IsR0FDSCxJQURHLENBQ2xCQSxXQURrQjs7QUFFaEMsZ0JBQUlBLFdBQUosRUFBaUI7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFDYixvRUFBbUJBLFdBQW5CLDRHQUFnQztBQUFBLDRCQUFyQkMsSUFBcUI7O0FBQzVCLDRCQUFJLENBQUNDLGtCQUFXQyxZQUFYLENBQXdCSixNQUFNRSxJQUFOLENBQXhCLEVBQXFDSCxTQUFTRyxJQUFULENBQXJDLENBQUwsRUFBNkQ7QUFDekQsaUNBQUtHLFlBQUwsQ0FBa0JILElBQWxCLEVBQXdCSCxTQUFTRyxJQUFULENBQXhCO0FBQ0g7QUFDSjtBQUxZO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFNaEI7QUFDSjs7O3NDQUVhO0FBQUEsZ0JBQ0hJLElBREcsR0FDSyxLQUFLTixLQURWLENBQ0hNLElBREc7O0FBRVYsaUJBQUtDLFFBQUwsQ0FBYyxvQ0FBaUJELElBQWpCLEVBQXVCLElBQXZCLENBQWQ7QUFDSDs7O3FDQUVZO0FBQUEsZ0JBQ0ZBLElBREUsR0FDTSxLQUFLTixLQURYLENBQ0ZNLElBREU7O0FBRVQsaUJBQUtDLFFBQUwsQ0FBYyxvQ0FBaUJELElBQWpCLEVBQXVCLEtBQXZCLENBQWQ7QUFDSDs7O3VDQUVjO0FBQUEsZ0JBQ0pOLEtBREksR0FDa0IsSUFEbEIsQ0FDSkEsS0FESTtBQUFBLGdCQUNHQyxXQURILEdBQ2tCLElBRGxCLENBQ0dBLFdBREg7O0FBRVgsZ0JBQUlBLFdBQUosRUFBaUI7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFDYixxRUFBbUJBLFdBQW5CLGlIQUFnQztBQUFBLDRCQUFyQkMsSUFBcUI7O0FBQzVCLDZCQUFLRyxZQUFMLENBQWtCSCxJQUFsQixFQUF3QkYsTUFBTUUsSUFBTixDQUF4QjtBQUNIO0FBSFk7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUloQjtBQUNELGlCQUFLTSx1QkFBTDtBQUNIOzs7a0RBRXlCLENBQ3pCOzs7cUNBRVlOLEksRUFBTU8sSyxFQUFPO0FBQUEsZ0JBQ2ZILElBRGUsR0FDUCxLQUFLTixLQURFLENBQ2ZNLElBRGU7O0FBRXRCLGlCQUFLQyxRQUFMLENBQWMsK0JBQVlELElBQVosRUFBa0IsRUFBQ2YsTUFBTSxjQUFQLEVBQXVCVyxVQUF2QixFQUE2Qk8sWUFBN0IsRUFBbEIsQ0FBZDtBQUNIOzs7b0NBRVdmLEssRUFBTztBQUFBLGdCQUNSZ0IsT0FEUSxHQUNHLEtBQUtWLEtBRFIsQ0FDUlUsT0FEUTs7QUFFZixnQkFBSUEsT0FBSixFQUFhO0FBQ1RBLHdCQUFRaEIsS0FBUjtBQUNIO0FBQ0o7Ozt3Q0FrQmVpQixJLEVBQU07QUFBQSx5QkFDNEMsS0FBS1gsS0FEakQ7QUFBQSxnQkFDWFksSUFEVyxVQUNYQSxJQURXO0FBQUEsZ0JBQ0xDLEtBREssVUFDTEEsS0FESztBQUFBLHdDQUNFQyxPQURGO0FBQUEsZ0JBQ1dDLFdBRFgsa0NBQ3lCLEVBRHpCO0FBQUEsdUNBQzZCQyxNQUQ3QjtBQUFBLGdCQUM2QkEsTUFEN0IsaUNBQ3NDLEVBRHRDOztBQUVsQixnQkFBTUYscUNBQWNDLFdBQWQsQ0FBTjtBQUNBLGdCQUFJSCxRQUFRQSxLQUFLSyxJQUFqQixFQUF1QjtBQUNuQkgsd0JBQVFJLEtBQVIsR0FBZ0JOLEtBQUtLLElBQUwsQ0FBVUUsWUFBMUI7QUFDSDtBQUNELDhDQUFXSCxNQUFYLElBQW1CTCxVQUFuQixFQUF5QkcsZ0JBQXpCLEVBQWtDRCxZQUFsQztBQUNIOzs7MkNBRWtEO0FBQUEsZ0JBQXRDTyxTQUFzQyxTQUF0Q0EsU0FBc0M7QUFBQSxnQkFBM0JDLEdBQTJCLFNBQTNCQSxHQUEyQjtBQUFBLGdCQUF0QmYsSUFBc0IsU0FBdEJBLElBQXNCO0FBQUEsZ0JBQWJnQixVQUFhOztBQUMvQyxtQkFBTyw4QkFBQyxZQUFELDJCQUFPLFdBQVdGLFNBQWxCLEVBQTZCLEtBQUtDLEdBQWxDLEVBQXVDLE1BQU1mLElBQTdDLEVBQW1ELFdBQVcsS0FBS2pCLGFBQW5FLElBQXNGaUMsVUFBdEYsRUFBUDtBQUNIOzs7RUFoRitDQyxnQzs7QUFvRnBEOzs7OztrQkFwRnFCbkMsc0I7QUF1RmQsSUFBTW9DLHdEQUF3Qix5QkFBUTtBQUFBLFdBQ3pDLEVBQUNaLE1BQU0sMEJBQWNhLEtBQWQsRUFBcUJDLDJCQUFyQixDQUFQLEVBRHlDO0FBQUEsQ0FBUixDQUE5QiIsImZpbGUiOiJBYnN0cmFjdE1hcGlvQ29tcG9uZW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7Y29ubmVjdH0gZnJvbSAncmVhY3QtcmVkdXgnO1xuaW1wb3J0IEFic3RyYWN0UmVhY3RDb21wb25lbnQgZnJvbSAnLi4vQWJzdHJhY3RSZWFjdENvbXBvbmVudCc7XG5pbXBvcnQge0FVVEhfSU5GT19BUkVBfSBmcm9tICcuLi9hY3Rpb25zL2F1dGhBY3Rpb25zJztcbmltcG9ydCB7RnJhbWV9IGZyb20gJy4uL2ZyYW1lJztcbmltcG9ydCB7cG9zdE1lc3NhZ2UsIHNldFBvc3RTdXNwZW5kZWR9IGZyb20gJy4uL2ZyYW1lL0ZyYW1lQWN0aW9ucyc7XG5pbXBvcnQge3N0b3JlRnJvbUFyZWEsIFN0b3JlVXRpbHN9IGZyb20gJy4uL3V0aWxzJztcblxuLyoqXG4gKiBaw6FrbGFkIHBybyBtYXBpbyBrb21wb25lbnR5IHBvc3RhdmVuw6kgbmEgaWZyYW1lLlxuICovXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBBYnN0cmFjdE1hcGlvQ29tcG9uZW50IGV4dGVuZHMgQWJzdHJhY3RSZWFjdENvbXBvbmVudCB7XG5cbiAgICBjb21wb25lbnRXaWxsTW91bnQoKSB7XG4gICAgICAgIHRoaXMuc3VzcGVuZFBvc3QoKTtcbiAgICAgICAgdGhpcy5wb3N0RGVmYXVsdHMoKTtcbiAgICB9XG5cbiAgICBjb21wb25lbnRXaWxsUmVjZWl2ZVByb3BzKG5ld1Byb3BzKSB7XG4gICAgICAgIGNvbnN0IHtwcm9wcywgcHJvcHNUb1N5bmN9ID0gdGhpcztcbiAgICAgICAgaWYgKHByb3BzVG9TeW5jKSB7XG4gICAgICAgICAgICBmb3IgKGNvbnN0IG5hbWUgb2YgcHJvcHNUb1N5bmMpIHtcbiAgICAgICAgICAgICAgICBpZiAoIVN0b3JlVXRpbHMub2JqZWN0RXF1YWxzKHByb3BzW25hbWVdLCBuZXdQcm9wc1tuYW1lXSkgICkge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLnBvc3RQcm9wZXJ0eShuYW1lLCBuZXdQcm9wc1tuYW1lXSk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgfVxuXG4gICAgc3VzcGVuZFBvc3QoKSB7XG4gICAgICAgIGNvbnN0IHthcmVhfSA9IHRoaXMucHJvcHM7XG4gICAgICAgIHRoaXMuZGlzcGF0Y2goc2V0UG9zdFN1c3BlbmRlZChhcmVhLCB0cnVlKSk7XG4gICAgfVxuXG4gICAgcmVzdW1lUG9zdCgpIHtcbiAgICAgICAgY29uc3Qge2FyZWF9ID0gdGhpcy5wcm9wcztcbiAgICAgICAgdGhpcy5kaXNwYXRjaChzZXRQb3N0U3VzcGVuZGVkKGFyZWEsIGZhbHNlKSk7XG4gICAgfVxuXG4gICAgcG9zdERlZmF1bHRzKCkge1xuICAgICAgICBjb25zdCB7cHJvcHMsIHByb3BzVG9TeW5jfSA9IHRoaXM7XG4gICAgICAgIGlmIChwcm9wc1RvU3luYykge1xuICAgICAgICAgICAgZm9yIChjb25zdCBuYW1lIG9mIHByb3BzVG9TeW5jKSB7XG4gICAgICAgICAgICAgICAgdGhpcy5wb3N0UHJvcGVydHkobmFtZSwgcHJvcHNbbmFtZV0pO1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIHRoaXMuY29tcG9uZW50UG9zdGVkRGVmYXVsdHMoKTtcbiAgICB9XG5cbiAgICBjb21wb25lbnRQb3N0ZWREZWZhdWx0cygpIHtcbiAgICB9XG5cbiAgICBwb3N0UHJvcGVydHkobmFtZSwgdmFsdWUpIHtcbiAgICAgICAgY29uc3Qge2FyZWF9ID0gdGhpcy5wcm9wcztcbiAgICAgICAgdGhpcy5kaXNwYXRjaChwb3N0TWVzc2FnZShhcmVhLCB7dHlwZTogJ1BST1BFUlRZX1NFVCcsIG5hbWUsIHZhbHVlfSkpO1xuICAgIH1cblxuICAgIGhhbmRsZUV2ZW50KGV2ZW50KSB7XG4gICAgICAgIGNvbnN0IHtvbkV2ZW50fSA9IHRoaXMucHJvcHM7XG4gICAgICAgIGlmIChvbkV2ZW50KSB7XG4gICAgICAgICAgICBvbkV2ZW50KGV2ZW50KTtcbiAgICAgICAgfVxuICAgIH1cblxuICAgIGhhbmRsZU1lc3NhZ2UgPSBtZXNzYWdlID0+IHtcbiAgICAgICAgc3dpdGNoIChtZXNzYWdlLnR5cGUpIHtcbiAgICAgICAgICAgIGNhc2UgJ1JFQURZJzpcbiAgICAgICAgICAgICAgICB0aGlzLnJlc3VtZVBvc3QoKTsgLy8gQcW+IHRlxI8gbcWvxb5lbWUgemHEjcOtdCBrb211bmlrb3ZhdCBhIHBvc2xhdCB2w71jaG96w60ga29uZmlndXJhY2lcbiAgICAgICAgICAgICAgICBicmVhaztcblxuICAgICAgICAgICAgY2FzZSAnRVZFTlQnOlxuICAgICAgICAgICAgICAgIHRoaXMuaGFuZGxlRXZlbnQobWVzc2FnZS5ldmVudCk7XG4gICAgICAgICAgICAgICAgYnJlYWs7XG5cbiAgICAgICAgICAgIGRlZmF1bHQ6XG4gICAgICAgICAgICAgICAgY29uc29sZS53YXJuKCdVbnJlY29nbml6ZWQgbWVzc2FnZScsIG1lc3NhZ2UpO1xuICAgICAgICAgICAgICAgIGJyZWFrO1xuICAgICAgICB9XG4gICAgfTtcblxuICAgIGJ1aWxkVVJMT3B0aW9ucyhwYXRoKSB7XG4gICAgICAgIGNvbnN0IHthdXRoLCB0b3BpYywgY29udGV4dDogb3JpZ0NvbnRleHQgPSB7fSwgcGFyYW1zID0ge319ID0gdGhpcy5wcm9wcztcbiAgICAgICAgY29uc3QgY29udGV4dCA9IHsuLi5vcmlnQ29udGV4dH07XG4gICAgICAgIGlmIChhdXRoICYmIGF1dGguZGF0YSkge1xuICAgICAgICAgICAgY29udGV4dC5sb2dpbiA9IGF1dGguZGF0YS5sb2dpbkVuY29kZWQ7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIHsuLi5wYXJhbXMsIHBhdGgsIGNvbnRleHQsIHRvcGljfTtcbiAgICB9XG5cbiAgICByZW5kZXJGcmFtZSh7Y2xhc3NOYW1lLCBzcmMsIGFyZWEsIC4uLm90aGVyUHJvcHN9KSB7XG4gICAgICAgIHJldHVybiA8RnJhbWUgY2xhc3NOYW1lPXtjbGFzc05hbWV9IHNyYz17c3JjfSBhcmVhPXthcmVhfSBvbk1lc3NhZ2U9e3RoaXMuaGFuZGxlTWVzc2FnZX0gey4uLm90aGVyUHJvcHN9Lz47XG4gICAgfVxuXG59XG5cbi8qKlxuICogTmFwb2plbsOtIGRvIHJlZHV4IHN0b3JlLCBrdGVyw6kgcG91xb7DrXZhasOtIGtvbXBvbmVudHkgZMSbZMOtY8OtIG9kIEFic3RyYWN0TWFwaW9Db21wb25lbnQuXG4gKi9cbmV4cG9ydCBjb25zdCBjb25uZWN0TWFwaW9Db21wb25lbnQgPSBjb25uZWN0KHN0YXRlID0+IChcbiAgICB7YXV0aDogc3RvcmVGcm9tQXJlYShzdGF0ZSwgQVVUSF9JTkZPX0FSRUEpfVxuKSk7XG4iXX0=